import { Record } from "immutable";

import { BundleModel } from "./BundleModel";
import { IntegrationResourceRoleModel } from "./IntegrationResourceRoleModel";

type TTicketTargetType = "bundle" | "role";

const defaults = {
  bundle: null as BundleModel | null,
  id: "",
  integrationResourceRole: null as IntegrationResourceRoleModel | null,
  targetId: "",
  type: "" as TTicketTargetType,
};

export class TicketTargetModel extends Record<typeof defaults>(defaults) {
  get isDeleted(): boolean {
    if (this.type === "bundle") {
      return this.bundle?.isDeleted ?? false;
    }

    return this.integrationResourceRole?.isDeleted ?? false;
  }

  static fromServerData(data: unknown): TicketTargetModel {
    const { bundle, id, integrationResourceRole, targetId, type } = data as typeof defaults;
    return new TicketTargetModel({
      bundle: bundle ? BundleModel.fromServerData(bundle) : null,
      id,
      integrationResourceRole: integrationResourceRole
        ? IntegrationResourceRoleModel.fromServerData(integrationResourceRole)
        : null,
      targetId,
      type,
    });
  }
}
